// Packages
import axios from 'axios'

// Firebase
import { collection, doc, addDoc, setDoc } from 'firebase/firestore/lite'
import { db } from '@/main'

export default {
  data() {
    return {
      error: {
        isError: false,
        message: ''
      }
    }
  },
  methods: {
    async createEvent(eventData) {
      const reservationDetails = {
        name: eventData.name,
        start: eventData.date + ' ' + this.eventData.start,
        end: eventData.date + ' ' + this.eventData.end,
        category: eventData.anlage,
      }

      const userDetails = {
        verantw: eventData.verantw,
        email: eventData.email,
        phone: eventData.phone
      }
      const docId = await addDoc(
        collection(db, 'belegungsplan'),
        reservationDetails
      ).then(async (res) => {
        await setDoc(doc(db, 'belegungsplan', res.id, 'contact', 'verantw'), userDetails)
        return res.id
      }).catch((err) => {
        this.error = {
          isError: true,
          message: err
        }
        this.isSending = false

        console.log(this.error.message)
      })


      this.sendMail(docId)

    },
    async sendMail(doRefId) {
      const reservationDetails = {
        id: doRefId,
        type: 'admin-approval',
      }
      const mailData = Object.assign(reservationDetails)
      await axios
        .post(
          '/.netlify/functions/mailsender',
          JSON.stringify({
            mailData
          })
        )
        .then(() => {
          this.isSending = false
          this.isSuccess = true
          this.$refs.form.reset()
        })
        .catch((err) => {
          this.error = {
            isError: true,
            message: err
          }
          this.isSending = false
          console.log(this.error.message)

        })
    },
  },
}
